var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavNovaZadost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.25C16.5 9.66 16.16 10 15.75 10H8.25C7.84 10 7.5 9.66 7.5 9.25C7.5 8.84 7.84 8.5 8.25 8.5H15.75C16.16 8.5 16.5 8.84 16.5 9.25ZM6 22.5C5.17 22.5 4.5 21.83 4.5 21V3C4.5 2.17 5.17 1.5 6 1.5H14.25V4.5C14.25 5.74 15.26 6.75 16.5 6.75H19.5V11.32C20.03 11.49 20.54 11.73 21 12.03V6.75L14.25 0H6C4.34 0 3 1.34 3 3V21C3 22.66 4.34 24 6 24H17.5C15.92 24 14.47 23.44 13.35 22.5H6ZM17.5 24H18C18.33 24 18 24 17.5 24ZM8.25 13H12.82C13.43 12.36 14.17 11.85 15 11.5H8.25C7.84 11.5 7.5 11.84 7.5 12.25C7.5 12.66 7.84 13 8.25 13ZM8.25 16H11.18C11.29 15.53 11.46 15.07 11.67 14.64C11.55 14.56 11.41 14.5 11.25 14.5H8.25C7.84 14.5 7.5 14.84 7.5 15.25C7.5 15.66 7.84 16 8.25 16ZM23 17.5C23 20.54 20.54 23 17.5 23C14.46 23 12 20.54 12 17.5C12 14.46 14.46 12 17.5 12C20.54 12 23 14.46 23 17.5ZM21.75 17.5C21.75 17.09 21.41 16.75 21 16.75H18.25V14C18.25 13.59 17.91 13.25 17.5 13.25C17.09 13.25 16.75 13.59 16.75 14V16.75H14C13.59 16.75 13.25 17.09 13.25 17.5C13.25 17.91 13.59 18.25 14 18.25H16.75V21C16.75 21.41 17.09 21.75 17.5 21.75C17.91 21.75 18.25 21.41 18.25 21V18.25H21C21.41 18.25 21.75 17.91 21.75 17.5Z",
    fill: "#F9C13C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavNovaZadost);
export default __webpack_public_path__ + "static/media/nav_nova_zadost.4d3f50e0e20ee341c500ce8e0181b245.svg";
export { ForwardRef as ReactComponent };